export enum EErrorCode {
  NONE = "NONE",
  HTTP_REQUEST_FAIL = "HTTP_REQUEST_FAIL",
}
